function isGpuFieldPresent(value: unknown): boolean {
  if (value == null) return false;
  const s = String(value).trim();
  return s !== '' && s !== '-';
}

/** 根据 CPU / GPU 构造镜像列表查询参数（delivery-type-plugin 内 image / image-vm 共用） */
export function buildImageListQueryFromResource(source: {
  cpu?: string;
  gpu?: Record<string, unknown> | null;
  downloadType?: string;
}): Record<string, unknown> {
  const { cpu, gpu, downloadType } = source;
  const out: Record<string, unknown> = {};
  if (downloadType) {
    out.downloadType = downloadType;
  }

  if (cpu !== undefined && cpu !== null && String(cpu).trim() !== '') {
    out.cpu = cpu;
  }

  const gpuIsEmptyObject = gpu && typeof gpu === 'object' && Object.keys(gpu).length === 0;
  if (!gpu || typeof gpu !== 'object' || gpuIsEmptyObject) {
    return out;
  }

  const vendorId = gpu.vendorID ?? gpu.vendorId;
  const resourceType = gpu.code ?? 'GPU';
  const deviceId = gpu.deviceID ?? gpu.deviceId;

  if (isGpuFieldPresent(vendorId) && isGpuFieldPresent(resourceType) && isGpuFieldPresent(deviceId)) {
    out.hardwareOr = JSON.stringify([
      {
        vendorId: String(vendorId),
        resourceType: String(resourceType),
        deviceIdList: [String(deviceId)].filter((id) => isGpuFieldPresent(id)),
      },
    ]);
    return out;
  }

  return out;
}
